import clsx from "clsx";
import { Box, makeStyles, Typography, Card } from "@material-ui/core";
import Page from "src/components/Page";
import React from "react";
import Licence from "src/components/common/Licence";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
}));

const LicenceLogView = (rest) => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Deklaracja dostępności">
      {/* <KmPageTitle>Deklaracja dostępności</KmPageTitle> */}

      <Box mt={3}>
        <Card className={clsx(classes.root)}>
          <Box display="flex" flexDirection="column">
            <Licence></Licence>
          </Box>
        </Card>
      </Box>
    </Page>
  );
};

export default LicenceLogView;
